import isObfuscatedBySpecialChar from './isObfuscatedBySpecialChar.js';
import isCodeObfuscatedByEsotericSubset from './isCodeObfuscatedByEsotericSubset.js';
import isContainingRestrictedKeywords from './isContainingRestrictedKeywords.js';

export default function isMaliciousCode(code) {
  if (isObfuscatedBySpecialChar(code)) {
    return {
      isMalicious: true,
      reason: 'Obfuscated code: Heavy use of special char'
    };
  }

  if (isCodeObfuscatedByEsotericSubset(code)) {
    return {
      isMalicious: true,
      reason: 'Obfuscated code: Esoteric subset detected'
    };
  }

  const containsRestrictedKeywords = isContainingRestrictedKeywords(code);
  if (containsRestrictedKeywords) {
    return {
      isMalicious: true,
      reason: `Restricted keyword detected: ${containsRestrictedKeywords.match}`,
      detectedCode: containsRestrictedKeywords.detectedCode
    };
  }

  return {
    isMalicious: false
  };
}
